import classnames from 'classnames';
import React from 'react';
import { isEmpty, get } from 'lodash';
import Statuses, { Active, Deleted } from '../../../../../model/Statuses';
import useT from '../../../utils/Translations/useT';
export default function StatusAddon({ status: statusValue, className = 'display-inline-block text-size-small', customStatuses, customActiveStatus, customDeletedStatus, hasNoLeftMargin = false, }) {
    const t = useT();
    const activeStatus = customActiveStatus ? customActiveStatus : Active;
    const status = isEmpty(customStatuses)
        ? Statuses.BasicByValue[statusValue]
        : get(customStatuses, statusValue);
    if (!status || status === activeStatus) {
        return null;
    }
    const deletedStatus = customDeletedStatus ? customDeletedStatus : Deleted;
    return (<p className={classnames(className, {
        'ml-10': !hasNoLeftMargin,
        'text-grey-300': status !== deletedStatus,
        'text-danger-300': status === deletedStatus,
    })}>
      {t(status.name)}
    </p>);
}
